$(document).ready(function () {
  async function clearCart() {
    try {
      const response = await fetch(
        window.Shopify.routes.root + "cart/clear.js",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      return await response.json();
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  }

  async function addToCart(items) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error("Failed to add items to cart");
      const result = await response.json();
      updateCartDrawer();
    } catch (error) {
      console.error("Error adding items to cart:", error);
    }
  }

  function updateCartDrawer() {
    $.ajax({
      url: window.Shopify.routes.root + "?section_id=cart-drawer",
      method: "GET",
      success: function (response) {
        const newCartContent = $(response).find("cart-drawer").html();
        $("cart-drawer").html(newCartContent);
        initUpsellSliderToggle();
      },
      error: function (error) {
        console.error("Error updating cart drawer:", error);
      },
    });
  }

  async function handleSubscriptionToggle(event) {
    try {
      // const $checkbox = $(event.currentTarget);
      const $checkbox = $("#subscription-checkbox");
      const $parent = $checkbox.closest(".togggleSellingPlan");
      if ($parent) {
        $parent.addClass("loading");
      }

      const cartData = await fetchCartData();
      console.log("cartData", cartData);
      if (!$("#subscription-checkbox").is(":checked")) {
        cartData.forEach((item) => {
          delete item.selling_plan; // Removes the selling_plan property if it exists
        });
      }
      cartData.reverse();
      await clearCart();
      await addToCart(cartData);
      return true;
    } catch (error) {
      console.error("Error during subscription toggle:", error);
      return false;
    }
  }

  async function fetchCartData() {
    try {
      const response = await fetch(
        window.Shopify.routes.root + "?section_id=cart-items"
      );
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      let divContent = doc
        .querySelector("#shopify-section-cart-items")
        .textContent.trim();
      divContent = divContent.replace(/,\s*]/, "]").replace(/,\s*}/g, "}");
      return JSON.parse(divContent);
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return [];
    }
  }

  $("body")
    .off("click", "#subscription-checkbox")
    .on("click", "#subscription-checkbox", handleSubscriptionToggle);

  // Checkout button

  let allowCheckout = false;
  function handleCheckoutClick(event) {
    const $subscriptionCheckbox = $("#subscription-checkbox");
    const $popup = $("#vita-autoship-popup");
    console.log("checkout-btn", $subscriptionCheckbox.length);
    console.log("Checkbox Checked:", $subscriptionCheckbox.prop("checked"));
    if (
      $subscriptionCheckbox.length &&
      !$subscriptionCheckbox.prop("checked") &&
      !allowCheckout
    ) {
      event.preventDefault();
      $popup.show();
    }
  }
  function handlePopupActions() {
    $(".vita-yes")
      .off("click")
      .on("click", async function () {
        const $subscriptionCheckbox = $("#subscription-checkbox");
        const $popup = $("#vita-autoship-popup");
        const $checkoutButton = $("#CartDrawer-Checkout");

        try {
          $(this).prop("disabled", true);
          $popup.hide();
          if (!$subscriptionCheckbox.prop("checked")) {
            $subscriptionCheckbox.prop("checked", true).trigger("change");
            await handleSubscriptionToggle();
          }
          $checkoutButton.prop("disabled", false).trigger("click");
        } catch (error) {
          console.error("Error handling subscription toggle:", error);
        } finally {
          $(this).prop("disabled", false);
        }
      });

    $(".vita-no, .close").on("click", function () {
      const $popup = $("#vita-autoship-popup");
      allowCheckout = true;
      $popup.hide();
    });
  }

  $(document)
    .off("click", "#CartDrawer-Checkout")
    .on("click", "#CartDrawer-Checkout", handleCheckoutClick);

  handlePopupActions();

  function initUpsellSliderToggle() {
    let $slider = $(".drawer__upsell_products");

    if ($slider.length) {
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      $slider.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
      });
    }
  }
});
